import { useTranslation } from "react-i18next";
import IconStarInactive from "../../../layout/others/icon_star_idle.svg";
import IconStarActive from "../../../layout/others/icon_star_idle_yellow.svg";
import IconPencil from "../../../layout/others/pencil-svgrepo-com.svg";

export default function RoleInformationSection({
  children,
  interview,
  recommendedManagers,
  availabilityListStatus,
  getRecommendedByValue,
  openRecommendedForm,
  toggleFavorite,
  noActions
}) {
  let { t } = useTranslation();
  
  return (
    <div className="card inboard p-2 ">
      <section className="filters">
        <div className="row">
          <div className="col-md-2" style={{ width: "17%" }}>
            {" "}
            <div className="form-group">
              <div className="label-wrapper">
                <label>{t("Business Area")}</label>
              </div>
              <input
                id="businessAreaId"
                name="businessAreaId"
                className="text-truncate"
                value={
                  (interview.candidateBusinessAreas &&
                    interview.candidateBusinessAreas &&
                    interview.businessAreas
                      .map((x) => x.description)
                      .join(",")) ||
                  ""
                }
                title={
                  interview.candidateBusinessAreas &&
                  interview.businessAreas.map((x) => x.description).join(",")
                }
                disabled
              />
            </div>
          </div>
          <div className="col-md-2" style={{ width: "17%" }}>
            {" "}
            <div className="form-group">
              <div className="label-wrapper">
                <label>{t("Technical Area")}</label>
              </div>
              <input
                id="techAreaId"
                name="techAreaId"
                className="text-truncate"
                value={interview.personalInformation.techArea || ""}
                title={interview.personalInformation.techArea}
                disabled
              />
            </div>
          </div>
          <div className="col-md-2" style={{ width: "17%" }}>
            {" "}
            <div className="form-group">
              <div className="label-wrapper">
                <label>{t("Technical Role")}</label>
              </div>
              <input
                id="techRoleId"
                name="techRoleId"
                className="text-truncate"
                value={
                  (interview.personalInformation &&
                    interview.personalInformation.techRole) ||
                  ""
                }
                disabled
                title={interview.personalInformation.techRole}
              />
            </div>
          </div>
          <div className="col-sm-2" style={{ maxWidth: "15%" }}>
            <div className="form-group">
              <div className="label-wrapper">
                <label>{t("Manager Interest")}</label>
              </div>
              <input
                id="managerInterest"
                name="interestTypeId"
                className={
                  interview.personalInformation.interestType === "Not Hiring"
                    ? "notHireBorder text-truncate"
                    : "text-truncate"
                }
                value={interview.personalInformation.interestType || ""}
                disabled
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <div className="label-wrapper">
                <label>{t("Managers who received the share")}</label>
              </div>
              <input
                id="recommendBy"
                name="recommendBy"
                type="text"
                value={getRecommendedByValue()}
                disabled
              />
            </div>
          </div>
          <div className="col">
            {recommendedManagers?.length > 0 && (
              <div>
                <button
                  className="app-button btn-second btn-lg"
                  style={{
                    marginTop: "27px",
                    width: "36px",
                    height: "36px",
                    marginLeft: "-10px"
                  }}
                  type="button"
                  onClick={() => {
                    openRecommendedForm();
                  }}
                >
                  <img
                    src={IconPencil}
                    alt="iconpencil"
                    title={t("Recommended To")}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginTop: "-10px",
                      marginLeft: "-7px"
                    }}
                  />
                </button>
              </div>
            )}
          </div>
          <div className="col d-flex">
            {!noActions && (
              <>
                {" "}
                {interview.lastFeedback && (
                  <div
                    className="form-group"
                    style={{ marginRight: "17px", width: "110px" }}
                  >
                    <div className="label-wrapper">
                      <label>{t("Last Feedback")}</label>
                    </div>
                    <input
                      id="lastFeedbackDate"
                      name="lastFeedbackDate"
                      type="text"
                      value={interview.lastFeedback}
                      disabled
                    />
                  </div>
                )}
                <div
                  className="align-bottom me-3"
                  style={{ height: "35px", marginTop: "14px" }}
                >
                  <span title={t("Availability")}>
                    {!availabilityListStatus ? (
                      <i
                        class="bi bi-unlock"
                        style={{
                          fontSize: "2em"
                        }}
                      ></i>
                    ) : (
                      <i
                        class="bi bi-lock"
                        style={{
                          fontSize: "2em"
                        }}
                      ></i>
                    )}
                  </span>
                </div>
                <div
                  className="align-bottom me-3"
                  style={{ height: "35px", marginTop: "17px" }}
                >
                  <img
                    src={interview.favorite ? IconStarActive : IconStarInactive}
                    alt="ico-ppl"
                    title={t("Add to favorites")}
                    width="auto"
                    height="100%"
                    onClick={toggleFavorite}
                  />
                </div>
                {children}
              </>
            )}
          </div>
        </div>
        {interview.candidateInterestJobRoleDetailId && (
          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-md-2" style={{ width: "17%" }}>
              {" "}
              <div className="form-group">
                <div className="label-wrapper">
                  <label>{t("Business Area Interest")}</label>
                </div>
                <input
                  className="text-truncate"
                  value={
                    (interview.candidateBusinessAreas &&
                      interview.candidateBusinessAreas
                        .map((x) => x.description)
                        .join(",")) ||
                    ""
                  }
                  title={
                    interview.candidateBusinessAreas &&
                    interview.candidateBusinessAreas
                      .map((x) => x.description)
                      .join(",")
                  }
                  disabled
                />
              </div>
            </div>
            <div className="col-md-2" style={{ width: "17%" }}>
              {" "}
              <div className="form-group">
                <div className="label-wrapper">
                  <label>{t("Technical Area Interest")}</label>
                </div>
                <input
                  disabled
                  className="text-truncate"
                  value={
                    interview.personalInformation.candidateInterestTechArea ||
                    ""
                  }
                  title={
                    interview.personalInformation.candidateInterestTechArea
                  }
                  required
                />
              </div>
            </div>
            <div className="col-md-2" style={{ width: "17%" }}>
              {" "}
              <div className="form-group">
                <div className="label-wrapper">
                  <label>{t("Technical Role Interest")}</label>
                </div>
                <input
                  disabled
                  className="text-truncate"
                  value={
                    interview.personalInformation?.candidateInterestTechRole ||
                    ""
                  }
                  required
                  title={
                    interview.personalInformation?.candidateInterestTechRole
                  }
                />
              </div>
            </div>
            <div className="col"></div>
            <div className="col"></div>
          </div>
        )}
      </section>
    </div>
  );
}
